import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, TextField, Button, MenuItem } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGetOperatorsQuery, useGetFacilitiesQuery } from '../../api/endpoints/apiConfig';
import { toast } from 'react-toastify';
import { FacilityContext } from '../../context/FacilityContext';
const SalesCenterTesting: React.FC = () => {
    const navigate = useNavigate();
    const { data: operatorsData, isLoading: operatorsLoading, isError: operatorsError } = useGetOperatorsQuery();
    // Set a default operator ID (change '1' to your default operator ID)
    const [selectedOperator, setSelectedOperator] = useState<string>('1');
    const [facilityCode, setFacilityCode] = useState<string>('');
    const [externalId, setExternalId] = useState<string>('');
    const selectedOperatorId = selectedOperator ? Number(selectedOperator) : undefined;
    // Fetch facilities based on selected operator
    const { data: facilitiesData } = useGetFacilitiesQuery(selectedOperatorId!, {
        skip: !selectedOperatorId,
    });
    const context = useContext(FacilityContext);
    // Ensure the context is available
    if (!context) {
        throw new Error('FacilityContext must be used within a FacilityProvider');
    }

   // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { selectedFacility, setSelectedFacility } = context;
    const handleOperatorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setSelectedOperator(newValue);
        sessionStorage.setItem('operatorId', newValue); // Update session storage on selection change
    };
    const handleFacilityCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFacilityCode(event.target.value.toUpperCase());
    };
    const handleFacilityExternalIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setExternalId(event.target.value.toUpperCase());
    };
    const handleGo = () => {
        if (facilitiesData && facilitiesData.facilities) {
            const selectedFacility = facilitiesData.facilities.find(
                facility => facility.location_code === facilityCode
            );
            sessionStorage.setItem('facilityData', JSON.stringify(facilitiesData));
            if (selectedFacility) {
                // Store aircall_phone in session storage
                sessionStorage.setItem('aircall_phone', selectedFacility.aircall_phone);
                sessionStorage.setItem('operatorId', selectedFacility.operator_id.toString());
                sessionStorage.setItem("matchedFacilityId", selectedFacility.id.toString());

                const facilityId = Number(selectedFacility.id);
                if (!isNaN(facilityId)) {
                    setSelectedFacility({ label: `${selectedFacility.location_code}-${selectedFacility.name}`, id: facilityId }); // Update selectedFacility
                }
                // Set the selected facility ID and navigate to the dashboard
                navigate(`/Dashboard/${selectedFacility.id}`);
            } else {
                toast.info('Facility location code not found.');
            }
            sessionStorage.setItem('facilityData', JSON.stringify(selectedFacility));
        }
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (facilitiesData && facilitiesData.facilities) {
                const selectedFacility = facilitiesData.facilities.find(
                    facility => facility.location_code === facilityCode
                );
                sessionStorage.setItem('facilityData', JSON.stringify(selectedFacility));
                if (selectedFacility) {
                    // Store aircall_phone in session storage
                    sessionStorage.setItem('aircall_phone', selectedFacility.aircall_phone);
                    sessionStorage.setItem('operatorId', selectedFacility.operator_id.toString());
                    sessionStorage.setItem("matchedFacilityId", selectedFacility.id.toString());
                    // Set the selected facility ID and navigate to the dashboard
                    navigate(`/Dashboard/${selectedFacility.id}`);
                } else {
                    toast.info('Facility location code not found.');
                }
            }
        }
    };
    const handleFacilityIdGo = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (facilitiesData && facilitiesData.facilities) {
                const facilityExists = facilitiesData.facilities.find(facility => facility.external_id === externalId);
                sessionStorage.setItem('facilityData', JSON.stringify(facilityExists));
                if (facilityExists) {
                    // Store aircall_phone in session storage
                    sessionStorage.setItem('aircall_phone', facilityExists.aircall_phone);
                    navigate(`/Dashboard/${facilityExists.id}`);
                } else {
                    toast.info('Facility External ID not Found.');
                }
            }
        }
    };
    const handleIdGo = () => {

        if (facilitiesData && facilitiesData.facilities) {
            const facilityExists = facilitiesData.facilities.find(facility => facility.external_id === externalId);
            sessionStorage.setItem('facilityData', JSON.stringify(facilityExists));
            if (facilityExists) {
                // Store aircall_phone in session storage
                sessionStorage.setItem("matchedFacilityId", facilityExists.id.toString());
                const facilityId = Number(facilityExists.id);
                if (!isNaN(facilityId)) {
                    setSelectedFacility({ label: `${facilityExists.location_code}-${facilityExists.name}`, id: facilityId }); // Update selectedFacility
                }
                sessionStorage.setItem('aircall_phone', facilityExists.aircall_phone);
                navigate(`/Dashboard/${facilityExists.id}`);
            } else {
                toast.info('Facility External ID not Found.');
            }
        }
    };
    const handleFacilitySearch = () => {
        navigate('/Facility'); // Navigate to the Facility Search page
    };
    useEffect(() => {
        if (operatorsData && operatorsData.operators && operatorsData.operators.length > 0) {
            const firstOperator = operatorsData.operators[0];
            const operatorId = firstOperator.id.toString(); // Convert number to string
            setSelectedOperator(operatorId);
            sessionStorage.setItem('operatorId', operatorId); // Store in session storage
        }
    }, [operatorsData]);
    return (
        <Box sx={{ padding: 4, position: 'relative' }}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h1" align="center" fontWeight="bold" sx={{ color: '#333' }}>
                        Sales Center Test Page
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" align="center" sx={{ color: '#333' }}>
                        Use this page to simulate an incoming call
                    </Typography>
                </Grid>
                {/* Operator Selection */}
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="center" sx={{ mt: 4 }}>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <Typography variant="h5" fontWeight={600} sx={{ textAlign: 'center' }}>
                            Operator:
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 4 }}>
                        <TextField
                            select
                            fullWidth
                            value={selectedOperator}
                            onChange={handleOperatorChange}
                            variant="outlined"
                            size="small"
                            sx={{ fontSize: '1.2rem' }}
                            disabled={operatorsLoading || operatorsError}
                        >
                            {operatorsLoading ? (
                                <MenuItem disabled>Loading operators...</MenuItem>
                            ) : operatorsError ? (
                                <MenuItem disabled>Error loading operators</MenuItem>
                            ) : (
                                operatorsData?.operators?.map((operator: any) => (
                                    <MenuItem key={operator.id} value={operator.id}>
                                        {operator.name}
                                    </MenuItem>
                                ))
                            )}
                        </TextField>
                    </Grid>
                </Grid>
                {/* Facility Location Code */}
                <Grid container spacing={4} justifyContent="center" sx={{ mt: 6 }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Grid container direction="column" spacing={3}>
                            <Grid container alignItems="center" justifyContent="center">
                                <Grid size={{ xs: 12 }}>
                                    <Typography variant="h5" fontWeight={600} sx={{ textAlign: 'center' }}>
                                        Facility Location Code:
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        sx={{ fontSize: '1.2rem' }}
                                        value={facilityCode}
                                        onChange={handleFacilityCodeChange}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Facility Location Code"
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }} container justifyContent="center" sx={{ mt: 2 }}>
                                    <Button
                                        data-testid={"go-facility-loc"}
                                        variant="contained"
                                        sx={{ height: '100%', width: '100px', fontSize: '1.2rem' }}
                                        onClick={handleGo}
                                    >
                                        Go
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Facility ID */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Grid container direction="column" spacing={3}>
                            <Grid container alignItems="center" justifyContent="center">
                                <Grid size={{ xs: 12 }}>
                                    <Typography variant="h5" fontWeight={600} sx={{ textAlign: 'center' }}>
                                        Facility ID:
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        sx={{ fontSize: '1.2rem' }}
                                        value={externalId}
                                        onChange={handleFacilityExternalIdChange}
                                        onKeyDown={handleFacilityIdGo}
                                        placeholder="External Id"
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }} container justifyContent="center" sx={{ mt: 2 }}>
                                    <Button
                                        data-testid={"go-facility-id"}
                                        variant="contained"
                                        sx={{ height: '100%', width: '100px', fontSize: '1.2rem' }}
                                        onClick={handleIdGo}
                                    >
                                        Go
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Facility Search */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Grid container direction="column" spacing={3}>
                            <Grid container alignItems="center" justifyContent="center">
                                <Grid size={{ xs: 8 }} container justifyContent="center" sx={{ mt: 8 }}>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            fontSize: '1.2rem',
                                            padding: '8px 32px',
                                            paddingTop: '5px',
                                        }}
                                        onClick={handleFacilitySearch}
                                    >
                                        Facility Search
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Button
                variant="outlined"
                onClick={() => navigate('/WaitingPage')}
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 26,
                    fontSize: '1.2rem',
                    padding: '8px 16px',
                }}
            >
                Home
            </Button>
        </Box>
    );
};

export default SalesCenterTesting;
